import React from 'react';
import { string } from 'prop-types';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';

export default function Footer({ content = '', backgroundColor, fontFamily, corporationName }) {
  return (
    <footer className="footer" style={{ backgroundColor, fontFamily }}>
      <div className="footer-bottom">
        {!!content && (
          <article className="footer-left pd-custom fr-view">
            <FroalaEditorView model={content} />
          </article>
        )}
        {/* <a href="#primary-navigation" className="skip-link" aria-label="Skip to main content">
          Go to Navigation
        </a> */}
        <div className="footer-right">
          <span>
            Powered By
            <a href="//www.envisio.com/" target="_blank" rel="noopener noreferrer" title="Envisio logo">
              <img alt="Envisio logo" className="envisio-logo" src={`//${window.location.host}/img/envisio-logo.svg`} />
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  content: string,
  backgroundColor: string.isRequired,
  fontFamily: string.isRequired,
  corporationName: string.isRequired,
};
